import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";
import isNil from "lodash/isNil";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";
import { round } from "shared";

export type UpdateProductLine = ClientInferResponseBody<typeof contract.productLines.update>;

type UpdateProductLinesDto = ClientInferRequest<typeof contract.productLines.update>["body"];

export const updateProductLine = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateProductLinesDto;
}): Promise<UpdateProductLine> => {
  if (!id) {
    throw new Error("L'id de l'achat est requis");
  }

  const formatedPayload = {
    ...payload,
    price: !isNil(payload.price) ? round(payload.price) : undefined,
    fixedPrice: !isNil(payload.fixedPrice) ? round(payload.fixedPrice) : undefined,
  };

  if (payload.product) {
    formatedPayload.product = {
      ...payload.product,
      price: !isNil(payload.product.price) ? round(payload.product.price) : undefined,
      fixedPrice: !isNil(payload.product.fixedPrice)
        ? round(payload.product.fixedPrice)
        : undefined,
    };
  }

  const response = await api.productLines.update.mutation({
    params: {
      id,
    },
    body: formatedPayload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Erreur lors de la mise à jour de l'achat", response.status, response.body);
};
